import { range } from '~/utils'

import { DIRECTION } from '../types/pagination.types'

export default function getPaginationArray(
  totalPages: number,
  currPage?: number,
  navigationDirection?: DIRECTION | null,
): Array<string | number> {
  if (totalPages < 10) {
    return range(totalPages)
  }

  if (currPage !== undefined) {
    if (currPage < 3) {
      return [0, 1, 2, 'split', totalPages - 2, totalPages - 1]
    }

    if (currPage > totalPages - 4) {
      return [0, 1, 'split', totalPages - 3, totalPages - 2, totalPages - 1]
    }

    if (navigationDirection === DIRECTION.DOWN) {
      return [0, 'split-left', currPage - 1, currPage, 'split-right', totalPages - 1]
    }

    return [0, 'split-left', currPage, currPage + 1, 'split-right', totalPages - 1]
  }

  return []
}
